var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranchesFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#00c851;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(79 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.284 231)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M204.869,379.739h3.6v4.65h-3.6Z",
    transform: "translate(-183.468 -366.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M165.24,96.309h1.53v1.53h-1.53Z",
    transform: "translate(-145.232 -92.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M303.252,96.309h1.53v1.53h-1.53Z",
    transform: "translate(-278.392 -92.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M165.24,235.954h1.53v1.53h-1.53Z",
    transform: "translate(-145.232 -227.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M303.252,235.954h1.53v1.53h-1.53Z",
    transform: "translate(-278.392 -227.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.154,16.945H29.763V.527A.527.527,0,0,0,29.235,0H17.162a.527.527,0,0,0-.527.527V16.945H15.243a.527.527,0,1,0,0,1.055h5.1V12.823a.527.527,0,0,1,.527-.527h4.65a.527.527,0,0,1,.527.527V18h5.1a.527.527,0,0,0,0-1.055ZM27.444,2.859V5.443a.527.527,0,0,1-.527.527H24.332a.527.527,0,0,1-.527-.527V2.859a.527.527,0,0,1,.527-.527h2.584a.527.527,0,0,1,.527.527Zm-4.852,7.494a.527.527,0,0,1-.527.527H19.481a.527.527,0,0,1-.527-.527V7.768a.527.527,0,0,1,.527-.527h2.584a.527.527,0,0,1,.527.527Zm0-4.909a.527.527,0,0,1-.527.527H19.481a.527.527,0,0,1-.527-.527V2.859a.527.527,0,0,1,.527-.527h2.584a.527.527,0,0,1,.527.527Zm1.74,5.437a.527.527,0,0,1-.527-.527V7.768a.527.527,0,0,1,.527-.527h2.584a.527.527,0,0,1,.527.527v2.584a.527.527,0,0,1-.527.527Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchesFill);
export default __webpack_public_path__ + "static/media/branchesFill.935865cbead805db72575f139a5df3c9.svg";
export { ForwardRef as ReactComponent };